import type { JSX } from 'react'

export const LinesIcon = (): JSX.Element => (
  <use href='#linesIcon' height='100%' width='100%' />
)
